import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../base-components/Popup";
import CustomModal from "../../../base-components/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PhoneInput from "react-phone-input-2";
import {
  faCircleCheck,
  faEye,
  faEyeSlash,
  faPen,
  faTrash,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, IconButton, Menu, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import Tooltip from "@mui/material/Tooltip";
import { staffMemberValidationSchema } from "../../../schemas";
import dayjs from "dayjs";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getSessionUser, hasPermission, isDynamicStaffRole } from "../../../utils/roleAccess";
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function StaffMember() {
  const navigate = useNavigate();
  const [staffToDelete, setStaffToDelete] = useState("");
  const [staffToUpdate, setStaffToUpdate] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const [isSuccessAlert, setIsSuccessAlert] = useState(false);
  const [isFaliureAlert, setIsFailureAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [locations, setLocations] = useState([]);
  const [staffmember, setStaffmember] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [company_id, setCompanyID] = useState("");
  const [user_id, setUserId] = useState("");
  const [location_id, setLocationId] = useState("");
  const [role, setRole] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [assignableRoles, setAssignableRoles] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

   // Anchor state for the actions menu
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const openAnchor = Boolean(anchorEl);
    const handleClickAnchor = (event, staffId) => {
      setAnchorEl(event.currentTarget);
      setSelectedStaffId(staffId);
    };
    const handleCloseAnchor = () => {
      setAnchorEl(null);
      setSelectedStaffId(null);
    };

  useEffect(() => {
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setUserId(session.user._id);
      setCompanyID(session.user.company_id);
      setLocationId(session.user.location_id);
      console.log("ha bhai", session.user.company_id);
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (role) {
      setLoading(true);
      getAllStaffmember();
      getLocation();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [role]);

  useEffect(() => {
    if (user_id) {
      loadAssignableRoles();
    }
  }, [user_id]);

  const loadAssignableRoles = () => {
    if (!user_id) return;
    fetch(`${BASE_URL}company-staff-access/assignable-roles?actingUserId=${user_id}`)
      .then((response) => response.json())
      .then((data) => {
        setAssignableRoles(data.roles || []);
      })
      .catch((error) => {
        console.error("Error fetching assignable roles:", error);
        setAssignableRoles([]);
      });
  };

  const getAllStaffmember = () => {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = `staff/get-staff`;
    } else if (role === "Admin") {
      endpoint = `staff/get-staff-by-company-id/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `staff/get-staff-by-location-id/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `staff/get-staff-by-location-id/${location_id}`;
    }

    console.log("Role:", role);
    console.log("Company ID:", company_id);
    console.log("Endpoint:", endpoint);
    fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setStaffmember(Array.isArray(data.staff) ? data.staff : []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching staff members:", error);
        setStaffmember([]);
        setLoading(false);
      });
  };

  const getStaffById = (id) => {
    fetch(`${BASE_URL}staff/get-staff-by-id/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.staff) {
          setSelectedMember(data.staff);
          console.log("Selected Staff Member:", data.staff);
          setValues({
            name: data.staff.name,
            company_id: data.staff.company_id,
            location_id: data.staff.location_id._id,
            email: data.staff.email,
            hire_date: data.staff.hire_date,
            phone_number: data.staff.phone_number,
            address: data.staff.address,
            salary: data.staff.salary,
            employment_status: data.staff.employment_status,
            experience_year: data.staff.experience_year,
            work_schedule: data.staff.work_schedule,
            designation: data.staff.designation,
            additional_notes: data.staff.additional_notes,
            password: "",
            role: data.staff.portal_access?.role || "",
          });
        } else {
          console.error("No staff member found.");
          setIsFailureAlert(true);
          setFailureMessage("No staff member found for the provided ID.");
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      })
      .catch((error) => {
        console.error("Error fetching staff member by ID:", error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to fetch staff information.");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      });
  };

  async function getLocation() {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = "locations/getLocations";
    } else if (role === "Admin") {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    }

    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setLocations(data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleAddStaff = async (values, actions) => {
    setButtonLoading(true);
    console.log("Values before save:", values);
    // company_id / location_id may be objects when populated from session
    const companyId =
      typeof company_id === "object" && company_id?._id
        ? company_id._id
        : company_id;
    const locationId =
      typeof location_id === "object" && location_id?._id
        ? location_id._id
        : location_id;

    values.company_id = companyId;
    if (role === "ClubAdmin" || isDynamicStaffRole(role)) {
      values.location_id = locationId;
    }
    if (!values.location_id) {
      setButtonLoading(false);
      setIsFailureAlert(true);
      setFailureMessage("Location is required for staff members.");
      setIsPopupOpen(true);
      setTimeout(() => setIsPopupOpen(false), 5000);
      return;
    }
    values.added_by = user_id;
    values.actingUserId = user_id;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        BASE_URL + `staff/create-staff`,
        requestOptions
      );

      // Log the full response details
      console.log("Response status:", response.status);

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error message from server:", errorMessage);
        setIsFailureAlert(true);
        setFailureMessage(`Failed to add Staff: ${errorMessage}`);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);

        if (responseData && responseData.staff) {
          setIsAddModalOpen(false);
          actions.resetForm();
          getAllStaffmember();
          setIsSuccessAlert(true);
          setSuccessMessage(responseData.message);
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        } else {
          console.error("Unexpected response data:", responseData);
          setIsFailureAlert(true);
          setFailureMessage(responseData.message);
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to add Staff");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleUpdateStaff = async (values, actions) => {
    setButtonLoading(true);
    const companyId =
      typeof company_id === "object" && company_id?._id
        ? company_id._id
        : company_id;
    const locationId =
      typeof location_id === "object" && location_id?._id
        ? location_id._id
        : location_id;

    values.company_id = companyId;
    if (role === "ClubAdmin" || isDynamicStaffRole(role)) {
      values.location_id = locationId;
    }
    if (!values.location_id) {
      setButtonLoading(false);
      setIsFailureAlert(true);
      setFailureMessage("Location is required for staff members.");
      setIsPopupOpen(true);
      setTimeout(() => setIsPopupOpen(false), 5000);
      return;
    }
    values.added_by = user_id;
    values.actingUserId = user_id;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        `${BASE_URL}staff/update-staff/${staffToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        const responseData = await response.json();
        setIsFailureAlert(true);
        setFailureMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        actions.resetForm();
        setIsUpdateModalOpen(false);

        getAllStaffmember();
        setIsSuccessAlert(true);
        setSuccessMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to Update Staff");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
    }
  };

  function deleteStaff() {
    setButtonLoading(true)
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(BASE_URL + `staff/delete-staff/${staffToDelete}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getAllStaffmember();
        setIsDeleteModalOpen(false);
        setIsSuccessAlert(true);
        setSuccessMessage("Staff deleted Successfully");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to delete Staff");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }).finally(() => {
        setButtonLoading(false);
      });
  }

  function toggleAddModal() {
    setIsAddModalOpen(!isAddModalOpen);
    resetForm();
  }
  function toggleViewModal() {
    setIsViewModalOpen(!isViewModalOpen);
    resetForm();
  }

  function toggleUpdateModal() {
    setIsUpdateModalOpen(!isUpdateModalOpen);
    resetForm();
  }
  function toggleDeleteModal() {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  }

  function showAddModal(id) {
    loadAssignableRoles();
    setIsAddModalOpen(true);
  }
  function showViewModal(id) {
    getStaffById(id);
    setIsViewModalOpen(true);
  }
  const showUpdateModal = (id) => {
    loadAssignableRoles();
    getStaffById(id);
    setStaffToUpdate(id);
    setIsUpdateModalOpen(true);
  };

  function showDeleteModal(id) {
    setStaffToDelete(id);
    setIsDeleteModalOpen(true);
  }

  const totalPages = Math.ceil((staffmember?.length || 0) / rowsPerPage);

  const indexOfLastRow = (page + 1) * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Array.isArray(staffmember)
    ? staffmember.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_id: company_id|| " ",
      location_id: role === "ClubAdmin" ? location_id :'' ,
      name: "",
      email: "",
      phone_number: "",
      address: "",
      salary: "",
      hire_date: "",
      designation: "",
      employment_status: "",
      work_schedule: " ",
      additional_notes: "",
      experience_year:"",
      added_by: "user_id",
      password: "",
      role: "",
    },
    validationSchema: staffMemberValidationSchema(location_id ? true : false, isUpdateModalOpen),
    onSubmit: (values, actions) => {
      console.log("Form Submitted:", values);

      if (isAddModalOpen) {
        handleAddStaff(values, actions);
      } else if (isUpdateModalOpen) {
        handleUpdateStaff(values, actions);
      } else {
        console.error("No valid action specified for submission.");
      }
    },
  });
  console.log(values,"values")

  return (
    <>
      <div className="m-5">
        <PageHeader
          title="Staff Members"
          actions={
            hasPermission(getSessionUser(), 'staff_members:create') ? (
                <button
                className="gx-cta"
                onClick={showAddModal}
                >
                Add Staff
                </button>
            ) : null
          }
        />
      </div>
      { loading ? (
          
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
          
        ) :  staffmember && staffmember.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Access Role</TableCell>
                <TableCell>Phone Number </TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Salary</TableCell>
                <TableCell>Hire Date </TableCell>
                <TableCell>Employement Status</TableCell>
                {/* <TableCell>Work Schedule</TableCell> */}
                <TableCell>Additional Notes</TableCell>
          
                <TableCell>Added By</TableCell>
                {/* {role !== "ClubAdmin" && ( */}
                <TableCell>Actions</TableCell>
                {/* )} */}
              </TableRow>
            </TableHead>
            <TableBody>
              {currentRows.map((staff, index) => (
                <TableRow hover key={index}>
                  <TableCell>{staff.name}</TableCell>
                  <TableCell>{staff.email}</TableCell>
                  <TableCell>{staff.portal_access?.role || "—"}</TableCell>
                  <TableCell>{staff.phone_number}</TableCell>
                  <TableCell>{staff.address}</TableCell>
                  <TableCell>{staff.salary}</TableCell>
                  <TableCell>
                  {dayjs(staff.hire_date).format("MMM DD, YYYY")}
                  </TableCell>
                  <TableCell>{staff.employment_status}</TableCell>
                  {/* <TableCell>{staff.work_schedule}</TableCell> */}
                  <TableCell>{staff.additional_notes}</TableCell>
                  <TableCell>{staff.added_by?.name || "—"}</TableCell>

                  <TableCell>
                  {/* {role !== "ClubAdmin" && ( */}
                    <div className="flex gap-2">
                      <Tooltip title="Actions">
                      <IconButton onClick={(event) => handleClickAnchor(event, staff._id)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showViewModal(selectedStaffId);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className='mr-2'/> View 
                      </MenuItem>
                      {hasPermission(getSessionUser(), 'staff_members:update') && (
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showUpdateModal(selectedStaffId);
                        }}
                      >
                        <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                      </MenuItem>
                      )}
                      {hasPermission(getSessionUser(), 'staff_members:delete') && (
                      <MenuItem
                        onClick={() => {
                          handleCloseAnchor();
                          showDeleteModal(selectedStaffId);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                      </MenuItem>
                      )}
                    </Menu>
                    </div>
                  {/* )} */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={12}
                  count={staffmember.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-ful p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}


<CustomModal
  isModal={isAddModalOpen || isUpdateModalOpen}
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }}
  size="2xl"
>
  <h1 className="font-bold text-xl sm:text-2xl md:text-3xl text-gx-ink-soft p-3 sm:p-5 border-b mx-2">
    {isAddModalOpen ? "Add Staff Member" : "Update Staff Member"}
  </h1>

  <form
    onSubmit={handleSubmit}
    className="text-gx-ink-soft m-3 sm:m-5"
    autoComplete="off"
  >
    <div>
      <input type="hidden" name="company_id" value={values.company_id} />
    </div>

    {/* Name and Email */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
      <div className="w-full sm:w-1/2">
        <label>Name <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="name"
          placeholder="Enter Name"
          value={values.name || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.name && touched.name ? "border-red-600" : ""
          }`}
        />
        {touched.name && errors.name && (
          <p className="text-red-500 pl-2 italic">{errors.name}</p>
        )}
      </div>

      <div className="w-full sm:w-1/2">
        <label>Email <span className="text-red-600">*</span></label>
        <input
          type="email"
          name="email"
          placeholder="Enter Email"
          value={values.email || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.email && touched.email ? "border-red-600" : ""
          }`}
        />
        {touched.email && errors.email && (
          <p className="text-red-500 pl-2 italic">{errors.email}</p>
        )}
      </div>
    </div>

    {/* Phone and Location */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mt-3 sm:mt-5">
      <div className="w-full sm:w-1/2">
        <label>Phone Number <span className="text-red-600">*</span></label>
        <PhoneInput
          name='phone'
          country={"pk"}
          value={values.phone_number}
          onChange={(value) => setFieldValue("phone_number", value)}
          containerStyle={{ width: "100%" }}
          inputStyle={{ width: "100%" }}
        />
        {touched.phone_number && errors.phone_number && (
          <p className="text-red-500 pl-2 italic">{errors.phone_number}</p>
        )}
      </div>
      
      {(role === "SuperAdmin" || role === "Admin") && (
        <div className="w-full sm:w-1/2">
          <label>Location <span className="text-red-600">*</span></label>
          <select
            name="location_id"
            value={values.location_id || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
              errors.location_id && touched.location_id ? "border-red-600" : ""
            }`}
          >
            <option value="" disabled>Select Location</option>
            {locations?.map((location, index) => (
              <option key={index} value={location._id}>{location.name}</option>
            ))}
          </select>
          {touched.location_id && errors.location_id && (
            <p className="text-red-500 pl-2 italic">{errors.location_id}</p>
          )}
        </div>
      )}
    </div>

    {/* Designation and Salary */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mt-3 sm:mt-5">
      <div className="w-full sm:w-1/2">
        <label>Designation <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="designation"
          placeholder="Enter Designation"
          value={values.designation || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.designation && touched.designation ? "border-red-600" : ""
          }`}
        />
        {touched.designation && errors.designation && (
          <p className="text-red-500 pl-2 italic">{errors.designation}</p>
        )}
      </div>

      <div className="w-full sm:w-1/2">
        <label>Salary <span className="text-red-600">*</span></label>
        <input
          type="number"
          name="salary"
          placeholder="Enter Salary"
          value={values.salary || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.salary && touched.salary ? "border-red-600" : ""
          }`}
        />
        {touched.salary && errors.salary && (
          <p className="text-red-500 pl-2 italic">{errors.salary}</p>
        )}
      </div>
    </div>

    {/* Hire Date and Experience */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mt-3 sm:mt-5">
      <div className="w-full sm:w-1/2">
        <label>Hire Date <span className="text-red-600">*</span></label>
        <input
          type="date"
          name="hire_date"
          value={values.hire_date.toString("yyyy-MM-dd")}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.hire_date && touched.hire_date ? "border-red-600" : ""
          }`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.hire_date && errors.hire_date && (
          <p className="text-red-500 pl-2 italic">{errors.hire_date}</p>
        )}
      </div>

      <div className="w-full sm:w-1/2">
        <label>Experience <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="experience_year"
          placeholder="Enter Experience (in years)"
          value={values.experience_year}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.experience_year && touched.experience_year ? "border-red-600" : ""
          }`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.experience_year && errors.experience_year && (
          <p className="text-red-500 pl-2 italic">{errors.experience_year}</p>
        )}
      </div>
    </div>

    {/* Work Schedule and Employment Status */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mt-3 sm:mt-5">
      {/* <div className="w-full sm:w-1/2">
        <label>Work Schedule <span className="text-red-600">*</span></label>
        <input
          type="text"
          name="work_schedule"
          value={values.work_schedule || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.work_schedule && touched.work_schedule ? "border-red-600" : ""
          }`}
        />
        {touched.work_schedule && errors.work_schedule && (
          <p className="text-red-500 pl-2 italic">{errors.work_schedule}</p>
        )}
      </div> */}

      <div className="w-full sm:w-1/2">
        <label>Employment Status <span className="text-red-600">*</span></label>
        <select
          name="employment_status"
          value={values.employment_status}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.employment_status && touched.employment_status ? "border-red-600" : ""
          }`}
        >
          <option value="">Select Status</option>
          <option value="part-time">Part-Time</option>
          <option value="full-time">Full-Time</option>
          <option value="contract">Contract</option>
        </select>
        {touched.employment_status && errors.employment_status && (
          <p className="text-red-500 pl-2 italic">{errors.employment_status}</p>
        )}
      </div>
    </div>

    {/* Address and Additional Notes */}
    <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 mt-3 sm:mt-5">
      <div className="w-full sm:w-1/2">
        <label>Address <span className="text-red-600">*</span></label>
        <textarea
          name="address"
          placeholder="Enter Address"
          value={values.address || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          rows={3}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.address && touched.address ? "border-red-600" : ""
          }`}
        />
        {touched.address && errors.address && (
          <p className="text-red-500 pl-2 italic">{errors.address}</p>
        )}
      </div>

      <div className="w-full sm:w-1/2">
        <label>Additional Notes</label>
        <textarea
          name="additional_notes"
          placeholder="Enter Notes"
          value={values.additional_notes || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          rows={3}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
            errors.additional_notes && touched.additional_notes ? "border-red-600" : ""
          }`}
        />
        {touched.additional_notes && errors.additional_notes && (
          <p className="text-red-500 pl-2 italic">{errors.additional_notes}</p>
        )}
      </div>
    </div>

    <div className="mt-5 border-t pt-4">
      <h2 className="font-semibold text-lg mb-2">Portal access (optional)</h2>
      <p className="text-sm text-gx-ink-soft mb-3">Set a password and role so this staff member can log in with screen access for that role.</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="w-full sm:w-1/2">
          <label>{isUpdateModalOpen ? "New Password (optional)" : "Password"}</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder={isUpdateModalOpen ? "Leave blank to keep current" : "Enter Password"}
              value={values.password || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
                errors.password && touched.password ? "border-red-600" : ""
              }`}
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gx-ink-soft"
              onClick={() => setShowPassword(!showPassword)}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
          {touched.password && errors.password && (
            <p className="text-red-500 pl-2 italic">{errors.password}</p>
          )}
        </div>
        <div className="w-full sm:w-1/2">
          <label>Access Role</label>
          <select
            name="role"
            value={values.role || ""}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${
              errors.role && touched.role ? "border-red-600" : ""
            }`}
          >
            <option value="">No portal access</option>
            {assignableRoles.map((r) => (
              <option key={r._id} value={r.name}>{r.name}</option>
            ))}
          </select>
          {touched.role && errors.role && (
            <p className="text-red-500 pl-2 italic">{errors.role}</p>
          )}
        </div>
      </div>
    </div>

    <div className="flex justify-end items-center pt-3 mt-3 sm:mt-5 border-t">
      <button
        type="submit"
        className={`bg-blue-600 p-2 px-4 sm:px-5 rounded-lg text-white font-medium hover:bg-blue-700 text-sm sm:text-base ${buttonLoading ? "flex cursor-not-allowed bg-gray-400" : ""}`}
        disabled={buttonLoading}
      >
        {buttonLoading ? 'Submitting...' : isAddModalOpen ? 'Add Staff' : 'Update Staff'}
        {buttonLoading && (
          <CircularProgress size={20} className="ml-2" />
        )}
      </button>
    </div>
  </form>
</CustomModal>

<CustomModal
  isModal={isViewModalOpen}
  handleModal={toggleViewModal}
  size="2xl"
>
  
    <div>
      <Tooltip title="" placement="bottom">
        <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2 sm:text-2xl">
          View Staff
        </h1>
        <div className="m-4 sm:m-6 max-h-[70vh] overflow-y-auto">
          <Box>
            <Table className="w-full">
              <TableBody>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Location</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.location_id.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Name</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Email</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.email}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Phone Number</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.phone_number}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Address</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.address}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Salary</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.salary}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Hire Date</TableCell>
                  <TableCell className="text-sm sm:text-base">
                    {dayjs(selectedMember?.hire_date).format("MMM DD, YYYY")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Employment Status</TableCell>
                  <TableCell className="text-sm sm:text-base">
                    {selectedMember?.employment_status}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Work Schedule</TableCell>
                  <TableCell className="text-sm sm:text-base">{selectedMember?.work_schedule}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-sm sm:text-base">Additional Notes</TableCell>
                  <TableCell className="text-sm sm:text-base">
                    {selectedMember?.additional_notes}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>




      <CustomModal
        isModal={isDeleteModalOpen}
        handleModal={toggleDeleteModal}
        size="md"
      >
        <div className="m-5">
          <h2 className="text-xl font-medium">Delete Staff?</h2>
          <p className="text-gx-ink-soft mt-3">
            Are you sure you want to delete this staff?
          </p>
          <button
            className={`bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`}
            onClick={deleteStaff}
            disabled={buttonLoading}
          >
            {buttonLoading ? 'Deleting...' : 'Delete Staff'}
            {buttonLoading && (
              <CircularProgress size={20} className="ml-2" />
            )}
          </button>
        </div>
      </CustomModal>
      {isPopupOpen && (
        <Popup
          onClose={() => setIsPopupOpen(false)}
          alertType={
            isSuccessAlert ? "success" : isFaliureAlert ? "failure" : ""
          }
          message={
            isSuccessAlert
              ? successMessage
              : isFaliureAlert
              ? failureMessage
              : ""
          }
        />
      )}
    </>
  );
}

export default StaffMember;
